import { Modal, styled } from '@mui/material';

export const AgreeServiceTermsModal = styled(Modal)(({ _ }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
